import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Icon from '@material-ui/core/Icon';

import { getPageScrollY } from 'cityads-v3/utils/htmlUtils';

import FABItem from './FabItem';
import classes from './Fab.scss';

const BALL_FIXED_TOP = 72;
const BALL_RADIUS = 58;
const BALL_MARGIN = 24;

export default class FAB extends Component {

  static propTypes = {
    className: PropTypes.string,
    show: PropTypes.bool,
    items: PropTypes.array
  }

  state = {
    open: false,
    fixed: false,
    posTop: this.props.posTop || null
  }

  fabMountTop = BALL_FIXED_TOP

  componentDidMount() {
    window.addEventListener('scroll', this._scrollEvent = this.scrollEvent.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this._scrollEvent);
  }

  scrollEvent() {
    const sTop = getPageScrollY();

    if (sTop + BALL_FIXED_TOP >= this.fabMountTop) {
      this.setState({
        fixed: true,
        posTop: BALL_FIXED_TOP
      });
    } else {
      this.setState({
        fixed: false,
        posTop: null
      });
    }
  }

  toggleOpen = () => {
    this.setState({
      open: !this.state.open
    });
  }

  svgFilter = (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
      <defs>
        <filter id="shadowed-goo">
          <feGaussianBlur in="SourceGraphic" result="blur" stdDeviation="10" />
          <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" result="goo" />
          <feGaussianBlur in="goo" stdDeviation="3" result="shadow" />
          <feColorMatrix in="shadow" mode="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 1 -0.2" result="shadow" />
          <feOffset in="shadow" dx="1" dy="1" result="shadow" />
          <feComposite in2="shadow" in="goo" result="goo" />
          <feComposite in2="goo" in="SourceGraphic" result="mix" />
        </filter>
        <filter id="goo">
          <feGaussianBlur in="SourceGraphic" result="blur" stdDeviation="10" />
          <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" result="goo" />
          <feComposite in2="goo" in="SourceGraphic" result="mix" />
        </filter>
      </defs>
    </svg>
  )

  render () {
    const items = this.props.items.map((item, num) => {
      return (
        <FABItem
          key      = {num}
          open     = {this.state.open}
          position = {num}
          radius   = {BALL_RADIUS}
          margin   = {BALL_MARGIN}
          item     = {item}
          onClick  = {this.toggleOpen}
        />
      );
    });

    const containerStyle = {
      minWidth: this.state.open ? '300px' : '',
      height: (this.state.open ? (BALL_RADIUS + BALL_MARGIN) * (items.length + 1) : BALL_RADIUS) + 'px',
    };

    return this.props.show ? (
      <div
        className={classNames(this.props.className, classes.fab, { [classes.fabFixed]: this.state.fixed })}
        style={{
          ...containerStyle,
          top: this.state.posTop === null ? '' : this.state.posTop + 'px'
        }}
      >
        <div
          className={classNames(classes.shadow, { [classes.shadowActive]: this.state.open })}
          onClick={this.toggleOpen}
        ></div>


        <div className={classes.goo} style={containerStyle}>
          <div
            className={classNames(classes.ball, classes.ballToggle, { [classes.ballOpened]: this.state.open })}
            onClick={this.toggleOpen}
          ><Icon>person_add</Icon></div>

          {items}
        </div>
        {this.svgFilter}
      </div>
    ) : false;
  }
}

